export const LOCALES = {
  ru: 'ru'
} as const;
